<template>
  <Drawer
    :id="drawerId"
    title="Print Preview"
    :iframed="iframed"
  >
    <template #cart>
      <mcs-btn
        icon
        color="black"
        prepend-icon="mdi-refresh"
        @click="$refs.edit.getMaterialQuantities()"
      ></mcs-btn>
    </template>
    <div class="mt-5">
      <PrintEditItem
        ref="edit"
        preview
        :drawerId="drawerId"
      />
    </div>
  </Drawer>
</template>

<script>
import PrintEditItem from '@/components/print/checkout/edititem/Index';
import { mapGetters } from 'vuex';
import Drawer from '../../components/layout/Drawer';
import { DRAWERS } from '../../utils/constants';

export default {
  name: 'PrintPreviewDrawer',

  components: {
    Drawer,
    PrintEditItem
  },

  props: {
    iframed: Boolean
  },

  data() {
    return {
      drawerId: DRAWERS.PRINT_PREVIEW
    };
  },

  computed: {
    ...mapGetters({
      initialData: 'drawers/data',
      drawerOpenedAt: 'drawers/lastOpenedAt'
    })
  },

  watch: {
    drawerOpenedAt(val, oldVal) {
      if (this.drawerId === this.$store.getters['drawers/topDrawer']?.id) {
        this.editItem(this.initialData(this.drawerId) || {});
      }
    }
  },

  methods: {
    editItem(item) {
      this.$store.dispatch('printcart/setEditItem', item).then(async () => {
        await this.$refs.edit.loadData();
      });
    }
  }
};
</script>
